// 尚未按需加载的
import WeaAddNotice from './wea-addnotice';
import WeaMaterialLib from './wea-materiallib';
import MaterialLib from './wea-materiallib/MaterialLib';
import WeaThemeCenter from './wea-theme-center';
import WeaThemeLayout from './wea-theme-layout';
import WeaPortalShare from './wea-portal-share';
import WeaPortalLayout from './wea-portal-layout';
import WeaExportElements from './wea-protal-exele';
import WeaElementPreview from './wea-element-preview';
import WeaMenu from './wea-menu';

// 已经按需加载的
import Loadable from 'react-loadable';
import WeaSystemSetting from './wea-system-setting';
import WeaPlugin from './components/wea-plugin';
import WeaNonStandard from './components/wea-non-standard';
import WeaLicense from './components/wea-license';
import WeaLicenseSubmit from './components/wea-license-submit';
import WeaVersion from './components/wea-version';
import WeaPortalUtils from './components/wea-portal-utils';
import WeaPortalRcTabs from './components/wea-portal-rc-tabs';
import WeaPortalRcMenu from './components/wea-portal-rc-menu';
import WeaLoginPop from './components/wea-login-pop';
import './style';

const loadable = (loader, loading = () => null) => Loadable({ loader, loading });
const WeaFavourite = loadable(() => import('./components/wea-favourite'));
const WeaPortalReactSlider = loadable(() => import('./components/wea-portal-react-slick'));
const WeaPortalAlert = loadable(() => import('./components/wea-portal-alert'));
const WeaPortalNoRight = loadable(() => import('./components/wea-portal-noright'));
const WeaPortalQuickSearch = loadable(() => import('./components/wea-portal-quick-search'));
const WeaPortalToolbar = loadable(() => import('./components/wea-portal-toolbar'));
const WeaPortalToolbarMore = loadable(() => import('./components/wea-portal-toolbar-more'));
const WeaPortalAccount = loadable(() => import('./components/wea-portal-account'));
const WeaPortalAccountList = loadable(() => import('./components/wea-portal-account-list'));
const WeaPortalAccountMenu = loadable(() => import('./components/wea-portal-account-menu'));
const WeaPortalElementTabs = loadable(() => import('./components/wea-portal-element-tabs'));
const WeaPortalStyleBrowser = loadable(() => import('../portal/elements/components/common/setting_new/content/base/EPortalBrowser'));
const WeaPortalFloatArea = loadable(() => import('./components/wea-portal-floatarea'));

// 登录弹窗
window.doLoginPop = () => {
  if(window.hasloginpop){ }else{
    const div = document.createElement('div');
    document.body.appendChild(div);
    ReactDOM.render(<WeaLoginPop visible={true} from="login" />, div);
  }
  
};

module.exports = {
  WeaAddNotice,
  WeaMaterialLib,
  MaterialLib,
  WeaThemeCenter,
  WeaThemeLayout,
  WeaPortalShare,
  WeaPortalLayout,
  WeaExportElements,
  WeaElementPreview,
  WeaMenu,
  WeaPlugin,
  WeaNonStandard,
  WeaLicense,
  WeaLicenseSubmit,
  WeaSystemSetting,
  WeaVersion,
  WeaLoginPop,
  WeaFavourite,
  WeaPortalUtils,
  WeaPortalRcTabs,
  WeaPortalRcMenu,
  WeaPortalReactSlider,
  WeaPortalAlert,
  WeaPortalNoRight,
  WeaPortalQuickSearch,
  WeaPortalToolbar,
  WeaPortalToolbarMore,
  WeaPortalAccount,
  WeaPortalAccountList,
  WeaPortalAccountMenu,
  WeaPortalElementTabs,
  WeaPortalStyleBrowser,
  WeaPortalFloatArea,
};



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/index.js